var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('locale-field',_vm._b({attrs:{"suggest-locales":""},model:{value:(_vm.defaultLocale),callback:function ($$v) {_vm.defaultLocale=$$v},expression:"defaultLocale"}},'locale-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }